import template from './map.html';
import controller from './map.controller';
import './map.scss';

let mapComponent = {
  bindings: {
    item: "=",
    language: "<",
    model: "<"
  },
  template,
  controller,
  controllerAs: "vm"
};

export default mapComponent;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/map/map.component.js